export default Object.freeze({
  tokenString: 'conductor_auth_token',
  tokenMetadataString: 'conductor_auth_metadata', // For httpOnly cookies mode
  // Following regex is made to conform to the password policy described in https://link-labs.atlassian.net/browse/NEX-1559
  // Backend policy: 6-32 chars, at least one letter (any case), one number, one special char from: @ # $ % ^ & + = , . / ; ' _ -
  // No spaces allowed
  passwordRegex: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[@#$%^&+=,./;'_-])[a-zA-Z0-9@#$%^&+=,./;'_-]{6,32}$/,
});
